/* =============================================================
   INBAR+co — inbar-edc.js
   EDC product page scripts
   Extends ic-product.js — load AFTER it
============================================================= */

/* Science accordion — inherited from ic-product.js via DOMContentLoaded.
   No override needed unless EDC uses different selector.  */

/* Pairing step accordion — re-uses icToggleStep from ic-product.js */

/* FAQ toggle — re-uses icToggleFaq from ic-product.js */

/* Sticky bar — re-uses ic-product.js sticky logic.
   Override close-element selector to use .ic-p-close instead of .ic-p-also-like */
document.addEventListener('DOMContentLoaded', function() {
  var sticky  = document.getElementById('ic-sticky');
  var heroAtc = document.querySelector('.ic-p-hero__ctas');
  var closeEl = document.querySelector('.ic-p-close');
  if (!sticky || !heroAtc) return;
  function updateSticky() {
    var pastHero     = heroAtc.getBoundingClientRect().bottom < 0;
    var closeVisible = closeEl ? closeEl.getBoundingClientRect().top < window.innerHeight : false;
    sticky.classList.toggle('ic-sticky--visible', pastHero && !closeVisible);
  }
  window.addEventListener('scroll', updateSticky, { passive: true });
  updateSticky();
});

/* ADD-ON CHECKBOX — Aluminium Atomiser */
function icToggleAddon(checkbox) {
  var variantId = checkbox.dataset.variantId;
  if (!variantId || variantId === '') {
    console.warn('INBAR+co: Atomiser variant ID not set. Add via theme customizer.');
    checkbox.checked = false;
    return;
  }
  if (checkbox.checked) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function(r) { return r.ok ? r.json() : r.json().then(function(d) { throw new Error(d.description); }); })
    .then(function() {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    })
    .catch(function(err) {
      console.error('INBAR+co atomiser add error:', err.message);
      checkbox.checked = false;
    });
  } else {
    /* Remove from cart by setting quantity to 0 */
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 0 })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    })
    .catch(function(err) {
      console.error('INBAR+co atomiser remove error:', err.message);
    });
  }
}
window.icToggleAddon = icToggleAddon;
